import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Event } from '../../domain/models/event';

export interface EventsPayload {
  session: string;
  idi: number;
  user_id: number | null;
  pipefy_phase: string | null;
  events: Event[];
}

export interface EventsResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EventApiService {

  constructor(private http: HttpClient) { }

  /**
   * Sends events to the marketing backend
   * @param payload The events payload
   * @returns Observable of the response
   */
  sendEvents(payload: EventsPayload): Observable<EventsResponse> {
    // Use override-url header to point to marketing API
    const headers = new HttpHeaders({
      'override-url': environment.marketing_url
    });

    return this.http.post<EventsResponse>('yooga/events', payload, { headers });
  }
}

